const appAPiUrl = process.env.REACT_APP_API_URL;
const reportingApiUrl = process.env.REACT_APP_REPORT;
const mainUrl = window.location.hostname === 'localhost' ? 'http://localhost:5001/' : appAPiUrl;
const reportingUrl = window.location.hostname === 'localhost' ? 'http://localhost:7000/' : reportingApiUrl;
import { logout } from '../components/Security/securityReducer';
export const apiCall = async (options) => {
  const token = sessionStorage.getItem('token');
  const url = (options.reportingUrl ? reportingUrl : mainUrl) + options.url;
  return fetch(url, {
    method: options.method || 'GET',
    headers: {
      ...(options.noAuth ? {} : { Authorization: `${token}` }),
      ...(options.notJSON ? {} : { 'Content-Type': 'application/json' }),
      ...options.headers,
    },
    body: options.body ? (options.stringify ? JSON.stringify(options.body) : options.body) : null,
  })
    .then(async (response) => {
      const errorToReturn = options.errorObject
        ? { ...options.errorObject, status: response.status }
        : { error: options.errorMessage || 'There was an error processing your request.', status: response.status };

      if (response.status === 401 && options.checkSessionOut) {
        console.log('Session expired, logging out...');
        checkForSessionOut(response);
      } else if (options.onResponse) {
        console.log('Response received:', response);
        return await options.onResponse(response);
      } else if (response.status >= 400) {
        if (options.onError) {
          return await options.onError(response);
        } else {
          throw new Error('Network request failed');
        }
      } else if (response.status === 200) {
        if (options.onSuccess) return options.onSuccess(response);
        else return await response.json();
      } else if (options.onError) return await options.onError(response);
      else if (options.throwOnError) throw new Error(errorToReturn);
      else {
        console.error(errorToReturn);
        return errorToReturn;
      }
    })
    .catch((error) => {
      if (options.onFailure) return options.onFailure(error);
      else {
        console.error('API call failed:', error);
        throw error;
      }
    });
};

export function checkForSessionOut(response) {
  if (response.status === 401) {
    logout();
  }
}
